/**
 * PHP API historically returned JSON bodies without application/json, so axios
 * left response.data as a string. Parse JSON-looking strings once globally.
 */
import axios from "axios";

function tryParseJsonString(raw) {
  if (typeof raw !== "string") {
    return raw;
  }
  let s = raw.trim().replace(/^\uFEFF/, "");
  const iObj = s.indexOf("{");
  const iArr = s.indexOf("[");
  const candidates = [iObj, iArr].filter((n) => n >= 0);
  if (candidates.length === 0) {
    return raw;
  }
  const cut = Math.min(...candidates);
  if (cut > 0) {
    s = s.slice(cut);
  }
  if (!s.startsWith("{") && !s.startsWith("[")) {
    return raw;
  }
  try {
    return JSON.parse(s);
  } catch {
    return raw;
  }
}

axios.interceptors.response.use((response) => {
  response.data = tryParseJsonString(response.data);
  return response;
});
